var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-stack-2x",class:("fa-" + _vm.base + " text-" + _vm.baseColor)}),_c('i',{staticClass:"fa fa-stack-1x",class:("fa-" + _vm.icon + " text-" + _vm.iconColor)})])}
var staticRenderFns = []

export { render, staticRenderFns }